export const messages = {
  en: {
    owePayFeeOrder: {
      printNotice1: 'Notice 1',
      printNotice2: 'Notice 2',
      payerObj: 'Payer',
      feeType: 'Fee Type',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      feeId: 'Fee ID',
      startTime: 'Start Time',
      endTime: 'End Time',
      oweAmount: 'Owe Amount',
      paymentAmount: 'Payment Amount',
      yuan: 'Yuan',
      scanPay: 'Scan Payment',
      pay: 'Pay',
      paymentConfirm: 'Payment Confirmation',
      room: 'Room:',
      amount: 'Amount:',
      paymentMethod: 'Payment Method:',
      selectPaymentMethod: 'Required, please select payment method',
      remark: 'Remark:',
      inputRemark: 'Optional, please enter remark',
      authCode: 'Auth Code:',
      scanCodeTip: 'Please scan with scanner',
      confirmPayment: 'Confirm Payment',
      paymentTip: 'Payment Notice',
      paymentSuccess: 'Payment successful',
      mergePrint: 'Merge Print',
      printReceipt: 'Print Receipt',
      illegalOperation: 'Illegal operation',
      noOweData: 'No owe data currently',
      noSelectedFee: 'No fee selected',
      noSelectedFeeItem: 'No fee item selected',
      selectPaymentMethodTip: 'Please select payment method'
    },
    printOwnFee: {
      printTitle: 'Print Notice',
      validityDate: 'Validity Date:',
      selectEndTime: 'Required, please select end time',
      selectEndTimeTip: 'Please select end time'
    }
  },
  zh: {
    owePayFeeOrder: {
      printNotice1: '催缴单1',
      printNotice2: '催缴单2',
      payerObj: '收费对象',
      feeType: '费用类型',
      feeItem: '费用项目',
      feeFlag: '费用标识',
      feeId: '费用ID',
      startTime: '计费起始时间',
      endTime: '计费结束时间',
      oweAmount: '欠费金额',
      paymentAmount: '缴费金额',
      yuan: '元',
      scanPay: '扫码收费',
      pay: '缴费',
      paymentConfirm: '收费确认',
      room: '房屋：',
      amount: '金额：',
      paymentMethod: '支付方式：',
      selectPaymentMethod: '必填，请选择支付方式',
      remark: '备注：',
      inputRemark: '可填，请填写备注',
      authCode: '授权码：',
      scanCodeTip: '请用扫码枪扫码',
      confirmPayment: '确定收费',
      paymentTip: '缴费提示',
      paymentSuccess: '缴费成功',
      mergePrint: '合并打印',
      printReceipt: '打印收据',
      illegalOperation: '非法操作',
      noOweData: '当前没有欠费数据',
      noSelectedFee: '未选择费用',
      noSelectedFeeItem: '未选中要缴费的项目',
      selectPaymentMethodTip: '请选择支付方式'
    },
    printOwnFee: {
      printTitle: '打印催缴单',
      validityDate: '有效期至：',
      selectEndTime: '必填，请填写截止时间',
      selectEndTimeTip: '请选择截止时间'
}
  },
  'zh-TW': {
    owePayFeeOrder: {
      printNotice1: '催繳單1',
      printNotice2: '催繳單2',
      payerObj: '收費對象',
      feeType: '費用類型',
      feeItem: '費用項目',
      feeFlag: '費用標識',
      feeId: '費用ID',
      startTime: '計費起始時間',
      endTime: '計費結束時間',
      oweAmount: '欠費金額',
      paymentAmount: '繳費金額',
      yuan: '元',
      scanPay: '掃碼收費',
      pay: '繳費',
      paymentConfirm: '收費確認',
      room: '房屋：',
      amount: '金額：',
      paymentMethod: '支付方式：',
      selectPaymentMethod: '必填，請選擇支付方式',
      remark: '備註：',
      inputRemark: '可填，請填寫備註',
      authCode: '授權碼：',
      scanCodeTip: '請用掃碼槍掃碼',
      confirmPayment: '確定收費',
      paymentTip: '繳費提示',
      paymentSuccess: '繳費成功',
      mergePrint: '合併列印',
      printReceipt: '列印收據',
      illegalOperation: '非法操作',
      noOweData: '目前沒有欠費資料',
      noSelectedFee: '未選擇費用',
      noSelectedFeeItem: '未選中要繳費的項目',
      selectPaymentMethodTip: '請選擇支付方式'
    },
    printOwnFee: {
      printTitle: '列印催繳單',
      validityDate: '有效期至：',
      selectEndTime: '必填，請填寫截止時間',
      selectEndTimeTip: '請選擇截止時間'
    }
  }
}